import FAQPageRightPart from '../../components/FAQPage/FAQPageRightPart/FAQPageRightPart';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(FAQPageRightPart);
